import { useAuth } from "../auth/AuthContext";

/**
 * One primary button — there is no second way in for a new app (§3.7). This
 * app issues no credentials of its own, so there is nothing else to offer.
 *
 * Normally unseen: AuthProvider redirects to the Hub as soon as it learns
 * there is no session. This exists for the case where that redirect is
 * blocked, so the user is never left on a blank page.
 */
export function Login() {
  const { login } = useAuth();

  return (
    <main className="grid min-h-dvh place-items-center bg-gray-100 p-4">
      <div className="w-full max-w-[400px] rounded-xl bg-white p-8 shadow-lg">
        <h1 className="text-display-xs font-semibold text-gray-900">CE Hub</h1>
        <p className="mt-2 text-sm text-gray-600">Sign in with your Euler account to continue.</p>
        <button
          type="button"
          onClick={login}
          className="mt-6 w-full rounded-md bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-700 focus-visible:focus-ring"
        >
          Sign in with Slack
        </button>
      </div>
    </main>
  );
}
